// extracted by mini-css-extract-plugin
module.exports = {"headContainer":"Audience_headContainer__s24-a","segment":"Audience_segment__3U37g"};